export default __webpack_public_path__ + "static/media/border.65ebf461.png";